export default __webpack_public_path__ + "static/media/offer_tag_orange.9b81d92c.svg";